import firebase from "../Config/firebase"

import {isEmpty, isLoaded} from "react-redux-firebase";

const db = firebase.firestore()

export const uiConfig = {
    signInFlow: "redirect",
    signInOptions: [
        firebase.auth.GoogleAuthProvider.PROVIDER_ID,
        firebase.auth.EmailAuthProvider.PROVIDER_ID,
        firebase.auth.FacebookAuthProvider.PROVIDER_ID
    ],
    callbacks: {
        signInSuccess: () => {
            firebase.analytics().logEvent('login');
            this.props.history.push({pathname: "/login"})
        }
    }
}

export function isAuth(auth) {
    return isLoaded(auth) && !isEmpty(auth)
}


export function logout(firebase) {
    firebase.auth().signOut()
        .then(function () {
            // Sign-out successful.
        })
        .catch(function (error) {
            // An error happened
        });
}

export function isUndefined(parm) {
    return typeof parm === 'undefined' || parm === '0' || parm === 0 || parm === false
}

export function getFirebaseCustomClaim(auth) {
    return new Promise((resolve, reject) => {
        if (isAuth(auth)) {
            firebase.auth().currentUser.getIdTokenResult()
                .then(idTokenResult => {
                    if (idTokenResult.claims.hasOwnProperty("userName") && Array.isArray(idTokenResult.claims.userName)) {
                        let newArr = []
                        idTokenResult.claims.userName.map(e => {
                            newArr.push({
                                value: e,
                                label: e
                            })
                        })
                        resolve({
                            success: true,
                            userName: newArr
                        })
                    } else {
                        resolve({
                            success: true,
                            userName: [{value: "å¿å", label: "å¿å"}]
                        })
                    }
                })
        }
    })

}

export function isHost() {
    return window.location.host === 'tmingler.com'
}

export function getUID(
    PUSH_CHARS = '-0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ_abcdefghijklmnopqrstuvwxyz',
    lastPushTime = 0,
    lastRandChars = []
) {
    var now = new Date().getTime();
    var duplicateTime = (now === lastPushTime);
    lastPushTime = now;

    var timeStampChars = new Array(8);
    for (var i = 7; i >= 0; i--) {
        timeStampChars[i] = PUSH_CHARS.charAt(now % 64);
        // NOTE: Can't use << here because javascript will convert to int and lose the upper bits.
        now = Math.floor(now / 64);
    }
    if (now !== 0) throw new Error('We should have converted the entire timestamp.');

    var id = timeStampChars.join('');

    if (!duplicateTime) {
        for (i = 0; i < 12; i++) {
            lastRandChars[i] = Math.floor(Math.random() * 64);
        }
    } else {
        // If the timestamp hasn't changed since last push, use the same random number, except incremented by 1.
        for (i = 11; i >= 0 && lastRandChars[i] === 63; i--) {
            lastRandChars[i] = 0;
        }
        lastRandChars[i]++;
    }
    for (i = 0; i < 12; i++) {
        id += PUSH_CHARS.charAt(lastRandChars[i]);
    }
    if (id.length !== 20) throw new Error('Length should be 20.');

    return id;

}

export function isIncludeBlob(content) {
    return content.includes('src="data:image/')
}

export async function getDownloadLink(path) {
    return new Promise(async (resolve, reject) => {
        await firebase
            .storage()
            .ref()
            .child(path)
            .getDownloadURL()
            .then((res) => {
                return resolve({
                    success: true,
                    downloadLink: res
                })
            })
            .catch((err) => {
                return resolve({
                    success: false,
                    message: err
                })
            })
    })

}

export async function removeFileFromStorage(cid, sectionID, fileName) {
    console.log(cid, sectionID, fileName)
    return new Promise(async (resolve, reject) => {

        const MyImage = await new Promise((resolve1, reject) => {
            firebase
                .storage()
                .ref('Community/' + cid + '/Report/' + sectionID + "/" + fileName)
                .delete()
                .then(() => {
                    return resolve1({success: true})
                })
                .catch(err => resolve1({success: true}))
        })

        const Thumbnail = await new Promise((resolve1, reject) => {
            firebase
                .storage()
                .ref('Community/' + cid + '/Thumbnail/' + fileName)
                .delete()
                .then(() => {
                    return resolve1({success: true})
                })
                .catch(err => resolve1({success: true}))
        })


        if (MyImage.success) {
            db.collection('Community')
                .doc(cid)
                .collection("Report")
                .doc(sectionID)
                .collection('Images')
                .doc(fileName)
                .delete()
                .then(res => {
                    resolve({success: true})
                })
                .catch(err => resolve({success: false}))

        }


    })

}